import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var OutlineItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OutlineItem, _React$PureComponent);
  var _super = _createSuper(OutlineItem);
  function OutlineItem() {
    var _this;
    _classCallCheck(this, OutlineItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onClick = function (event) {
      var _this$props = _this.props,
        scrollToNode = _this$props.scrollToNode,
        node = _this$props.node;
      scrollToNode && scrollToNode(node);
    };
    return _this;
  }
  _createClass(OutlineItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hash = decodeURI(window.location.hash);
      hash = hash.substring(1, hash.length);
      var _this$props2 = this.props,
        node = _this$props2.node,
        scrollToNode = _this$props2.scrollToNode;
      if (hash && node && hash === node.text) {
        scrollToNode && scrollToNode(node);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        node = _this$props3.node,
        isActive = _this$props3.isActive;
      var className = isActive ? 'active' : '';
      if (node.type === 'header_two') {
        className = 'outline-h2 ' + className;
      } else if (node.type === 'header_three') {
        className = 'outline-h3 ' + className;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        onClick: this.onClick
      }, node.children.map(function (child) {
        return child.text;
      }).join(''));
    }
  }]);
  return OutlineItem;
}(React.PureComponent);
export default OutlineItem;